<script>
import forminput from "../formcomponet/forminput.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznfirma from "@/models/mznfirma";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  mixins: [apibtoast, apigeneric, mznfirma],
  props: ["FormData"],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    forminput,
    formtextarea,
    Treeselect,
  },
  data() {
    return {};
  },
  methods: {
    Get() {
      if (this.FormData.Adresilid) {
        this.ilce_yukle(this.FormData.Adresilid);
      }
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.Update(this.$config.API_URL_2 + "mznfirma", this.FormData).then(
          (res) => {
            if (res) {
              this.$emit("TableUpdate");
            }
          }
        );
      }
    },

    ilce_yukle(ustid) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      (this.FormDataType.Adresilceid.ComboDataArray = []),
        this.ActionsFilterGet({ Service: "OIlIlce/" + ustid, Page: Page }).then(
          (res) => {
            this.ilkodu = res.Data.Kod;

            this.ActionsFilterGet({
              Service: "OIlIlce",
              Page: Page,
              Filter: "&Ustid=" + this.ilkodu,
            }).then((res) => {
              for (var i = 0; i < res.Data.length; i++) {
                this.FormDataType.Adresilceid.ComboDataArray.push({
                  id: res.Data[i].Id,
                  label: res.Data[i].Value,
                });
              }
            });
          }
        );
    },
  },
};
</script>

<template>
  <Loader>
    <div class="row">
      <div class="col-md-12">
        <div class="profile-detail">
          <div class="row d-flex align-items-center justify-content-center">
            <div class="col-md-12">
              <Form @submit.prevent="onSubmit">
                <forminput
                  :FormDataType="FormDataType.Firmaadi"
                  :Value="FormData.Firmaadi"
                  :v="$v.FormData.Firmaadi"
                  @input="FormData.Firmaadi = $event"
                />
                <div class="row">
                  <div class="col-md-6">
                    <forminput
                      :FormDataType="FormDataType.Telefon"
                      :Value="FormData.Telefon"
                      :v="$v.FormData.Telefon"
                      @input="FormData.Telefon = $event"
                    />
                  </div>
                  <div class="col-md-6">
                    <forminput
                      :FormDataType="FormDataType.Fax"
                      :Value="FormData.Fax"
                      :v="$v.FormData.Fax"
                      @input="FormData.Fax = $event"
                    />
                  </div>
                </div>
                <forminput
                  :FormDataType="FormDataType.Email"
                  :Value="FormData.Email"
                  :v="$v.FormData.Email"
                  @input="FormData.Email = $event"
                />
                <div class="row">
                  <div class="col-md-6">
                    <forminput
                      :FormDataType="FormDataType.Vergino"
                      :Value="FormData.Vergino"
                      :v="$v.FormData.Vergino"
                      @input="FormData.Vergino = $event"
                    />
                  </div>
                  <div class="col-md-6">
                    <forminput
                      :FormDataType="FormDataType.Vergidairesi"
                      :Value="FormData.Vergidairesi"
                      :v="$v.FormData.Vergidairesi"
                      @input="FormData.Vergidairesi = $event"
                    />
                  </div>
                </div>
                <formtextarea
                  :FormDataType="FormDataType.Firmaadresi"
                  :Value="FormData.Firmaadresi"
                  :v="$v.FormData.Firmaadresi"
                  @input="FormData.Firmaadresi = $event"
                />
                <formtextarea
                  :FormDataType="FormDataType.Aciklama"
                  :Value="FormData.Aciklama"
                  :v="$v.FormData.Aciklama"
                  @input="FormData.Aciklama = $event"
                />

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group
                      class="mb-3"
                      id="example text"
                      :label="FormDataType.Adresilid.FieldTitle"
                      label-for="text"
                    >
                      <treeselect
                        :multiple="false"
                        :options="FormDataType.Adresilid.ComboDataArray"
                        :placeholder="$t('OrtakKullanim.seciniz')"
                        @input="ilce_yukle(FormData.Adresilid)"
                        v-model="FormData.Adresilid"
                        :class="{ 'is-invalid': $v.FormData.Adresilid.$error }"
                      />
                      <treeselect-value :value="FormData.Adresilid" />

                      <div
                        v-if="$v.FormData.Adresilid.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="$v.FormData.Adresilid.required == false">{{
                          $t("ValidationMessage.required")
                        }}</span>
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      class="mb-3"
                      id="example text"
                      :label="FormDataType.Adresilceid.FieldTitle"
                      label-for="text"
                    >
                      <treeselect
                        :multiple="false"
                        :options="FormDataType.Adresilceid.ComboDataArray"
                        :placeholder="$t('OrtakKullanim.seciniz')"
                        v-model="FormData.Adresilceid"
                        :class="{
                          'is-invalid': $v.FormData.Adresilceid.$error,
                        }"
                      />
                      <treeselect-value :value="FormData.Adresilceid" />

                      <div
                        v-if="$v.FormData.Adresilceid.$error"
                        class="invalid-feedback"
                      >
                        <span
                          v-if="$v.FormData.Adresilceid.required == false"
                          >{{ $t("ValidationMessage.required") }}</span
                        >
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <button class="btn btn-primary" type="submit">
                  {{ $t("mznfirma.AddEdit.Button") }}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Loader>
</template>
